import { useEventDate } from '@/hooks/utils/useEventDate'
import { IEvent } from '@/types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'

import classNames from 'classnames'
import classes from './styles.module.scss'

interface StatusTagProps {
  event?: IEvent
  isLocked: boolean
  isLiveChannel?: boolean
}

export const CardEventInfo = ({ event, isLocked, isLiveChannel = false }: StatusTagProps) => {
  const { date, isTomorrow, isLive, isToday, isPast, isFuture } = useEventDate({
    shouldForceLive: isLiveChannel,
    event: event,
    format: 'date-time',
    soonThreshold: 120,
  })

  return (
    <div className={classes.slot}>
      {isLocked && (
        <div className={classNames(classes.slot__icon, {
          [classes.slot__today]: isToday,
          [classes.slot__tomorrow]: isTomorrow,
          [classes.slot__past]: isPast,
          [classes.slot__live]: isLive,
          [classes.slot__future]: isFuture,
        })}>
          <FontAwesomeIcon icon={faLock} size="xs" />
        </div>
      )}
      <div className={classNames({
        [classes.slot__today]: isToday,
        [classes.slot__tomorrow]: isTomorrow,
        [classes.slot__past]: isPast,
        [classes.slot__live]: isLive || isLiveChannel,
        [classes.slot__future]: isFuture,
      })}>
        <span>{date}</span>
      </div>
    </div>
  )
}